import PropTypes from 'prop-types';

var propTypes = {
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    buttonProps: PropTypes.object,
    withText: PropTypes.bool,
    textWhenChecked: PropTypes.string,
    textWhenUnchecked: PropTypes.string,
    disabled: PropTypes.bool,
    testId: PropTypes.string,
    'data-testid': PropTypes.string,
};
var defaultProps = {
    buttonProps: {},
};

export { defaultProps, propTypes };
